import { useCallback, useEffect, useState } from "react";
import { LngLat, UseGeolocationOptions } from ".";

export default function useGeolocation(
    { watch = false }: UseGeolocationOptions = {},
    positionOptions?: PositionOptions
) {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<GeolocationPositionError>();
    const [data, setData] = useState<LngLat | null>(null);
    const [isWatching, setIsWatching] = useState(false);

    const handleError = useCallback<PositionErrorCallback>((e) => {
        setError(e);
        setLoading(false);
    }, []);

    const handleSuccess = useCallback<PositionCallback>((e) => {
        setLoading(false);
        setError(null);
        setData({
            lng: e.coords.longitude,
            lat: e.coords.latitude,
        });
    }, []);

    const run = useCallback(() => {
        if (isWatching) {
            return;
        }

        navigator.geolocation.getCurrentPosition(handleSuccess, handleError, {
            timeout: 10000,
            ...(positionOptions ?? {}),
        });
    }, [positionOptions, isWatching]);

    useEffect(() => {
        run();

        if (!watch) {
            return;
        }

        setIsWatching(true);
        const id = navigator.geolocation.watchPosition(handleSuccess, handleError, {
            timeout: 10000,
            ...(positionOptions ?? {}),
        });
        return () => {
            navigator.geolocation.clearWatch(id);
            setIsWatching(false);
        };
    }, [watch, positionOptions]);

    return { loading, error, data, run };
}
